import { getState } from '~src/state';

export const gridProvinoIsEnabled = () => {
  const projectType = getState('selected.tipo');
  let projectTypeGridEnable = false;
  if (projectType.griglia_provino === true) {
    projectTypeGridEnable = true;
  }
  return projectTypeGridEnable;
};
